import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "../src/assets/iconfont/iconfont.js";
//引入toast、Dialog、DatePicker样式
import "vant/es/toast/style";
import "vant/es/dialog/style";
import "vant/es/date-picker/style";
import "@vant/touch-emulator";

// const VConsole = require("vconsole");
// new VConsole();
createApp(App).use(store).use(router).mount("#app");
